import { useMediaQuery } from '@uidotdev/usehooks';
import { useMemo } from 'react';
function readCssVariable(variableName) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return undefined;
    }
    const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
    if (value.length === 0) {
        return undefined;
    }
    return value;
}
function getTailwindBreakpointValues() {
    // Fallbacks align with Tailwind's default screens when not provided via CSS variables
    const sm = readCssVariable('--breakpoint-sm') ?? '640px';
    const md = readCssVariable('--breakpoint-md') ?? '768px';
    const lg = readCssVariable('--breakpoint-lg') ?? '1024px';
    const xl = readCssVariable('--breakpoint-xl') ?? '1280px';
    const twoXl = readCssVariable('--breakpoint-2xl') ?? '1536px';
    return { sm, md, lg, xl, '2xl': twoXl };
}
export function useQueryBreakpoint() {
    const breakpoints = useMemo(() => getTailwindBreakpointValues(), []);
    const is2xlUp = useMediaQuery(`only screen and (min-width: ${breakpoints['2xl']})`);
    const isXlUp = useMediaQuery(`only screen and (min-width: ${breakpoints.xl})`);
    const isLgUp = useMediaQuery(`only screen and (min-width: ${breakpoints.lg})`);
    const isMdUp = useMediaQuery(`only screen and (min-width: ${breakpoints.md})`);
    const current = useMemo(() => {
        if (is2xlUp) {
            return '2xl';
        }
        if (isXlUp) {
            return 'xl';
        }
        if (isLgUp) {
            return 'lg';
        }
        if (isMdUp) {
            return 'md';
        }
        return 'sm';
    }, [is2xlUp, isXlUp, isLgUp, isMdUp]);
    const is2xl = is2xlUp;
    const isXl = isXlUp && !is2xlUp;
    const isLg = isLgUp && !isXlUp;
    const isMd = isMdUp && !isLgUp;
    const isSm = !isMdUp;
    return {
        current,
        isMdUp,
        isLgUp,
        isXlUp,
        is2xlUp,
        isSm,
        isMd,
        isLg,
        isXl,
        is2xl
    };
}
//# sourceMappingURL=use-query-breakpoint.hook.js.map